import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import crossFetch from 'cross-fetch';
import { authLink, CLIENT_END_POINTS } from './shared';
/**
 * Function to create an Apollo client with an authenticated link.
 * @param {CLIENT_TYPE} clientType - The type of the client.
 * @param {CLIENT_ENV} env - The environment in which the client is running.
 * @param {string} oneGraphEndpoint - The endpoint for OneGraph.
 * @returns {ApolloClient<NormalizedCacheObject>} - The Apollo client with an authenticated link.
 */

var getAuthLink = function getAuthLink(clientType, env, oneGraphEndpoint) {
  var graphQLEndPoints = CLIENT_END_POINTS[clientType];
  return new ApolloClient({
    link: authLink.concat(new HttpLink({
      uri: oneGraphEndpoint || graphQLEndPoints[env || process.env.CHEGG_ENV || 'test'],
      credentials: 'include',
      headers: {
        'apollographql-client-name': 'DIPL'
      },
      fetchOptions: {
        credentials: 'include'
      },
      fetch: crossFetch
    })),
    cache: new InMemoryCache()
  });
};

var oneGraphClient;
/**
 * Function to get an Apollo client for OneGraph.
 * @param {CLIENT_ENV} env - The environment in which the client is running. Note: returns `.com` endpoints unless specifically passed using @oneGraphEndpoint prop
 * @param {string} oneGraphEndpoint - Pass the required non .com endpoint for OneGraph. eg: https://gateway.chegg.com.mx/one-graph/graphql
 * @returns {ApolloClient<NormalizedCacheObject>} - The Apollo client for OneGraph.
 */

export var getOneGraphClient = function getOneGraphClient(env, oneGraphEndpoint) {
  // on server-side we need to create a new client on every request to avoid memory leaks
  if (typeof window === 'undefined') {
    return getAuthLink('ONE_GRAPH', env);
  }

  oneGraphClient = oneGraphClient || getAuthLink('ONE_GRAPH', env, oneGraphEndpoint);
  return oneGraphClient;
};